"use strict";

var _objectSpread = require("/var/www/ivy-temp/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPOTLIGHT_ELIGIBILITY_RULE_DESCRIPTIONS = exports.SPOTLIGHT_ELIGIBILITY_RULE_LABELS = exports.SPOTLIGHT_MILES_PER_DEGREE = exports.MAX_SPOTLIGHT_RECENT_VIEWS_ELIGIBILITY_COUNT = exports.MAX_SPOTLIGHT_CHECKINS_ELIGIBILITY_COUNT = exports.MIN_SPOTLIGHT_ELIGIBILITY_COUNT = exports.MAX_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS = exports.MIN_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS = exports.MAX_SPOTLIGHT_SEARCH_RADIUS_DEGREES = exports.MIN_SPOTLIGHT_SEARCH_RADIUS_DEGREES = exports.DEFAULT_SPOTLIGHT_MIN_RECENT_VIEWS = exports.DEFAULT_SPOTLIGHT_MIN_CHECKINS = exports.DEFAULT_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS = exports.DEFAULT_SPOTLIGHT_SEARCH_RADIUS_DEGREES = void 0;
exports.spotlightSearchRadiusDegreesToMiles = spotlightSearchRadiusDegreesToMiles;
exports.spotlightSearchRadiusMilesToDegrees = spotlightSearchRadiusMilesToDegrees;
exports.buildDefaultSpotlightEligibilityConfig = buildDefaultSpotlightEligibilityConfig;
exports.parseSpotlightEligibility = parseSpotlightEligibility;
exports.hasEnabledSpotlightEligibilityRule = hasEnabledSpotlightEligibilityRule;
exports.ensureAtLeastOneSpotlightEligibilityRule = ensureAtLeastOneSpotlightEligibilityRule;
exports.validateSpotlightEligibilityForSave = validateSpotlightEligibilityForSave;
exports.DEFAULT_SPOTLIGHT_SEARCH_RADIUS_DEGREES = 0.5;
exports.DEFAULT_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS = 7;
exports.DEFAULT_SPOTLIGHT_MIN_CHECKINS = 1;
exports.DEFAULT_SPOTLIGHT_MIN_RECENT_VIEWS = 5;
exports.MIN_SPOTLIGHT_SEARCH_RADIUS_DEGREES = 0.05;
exports.MAX_SPOTLIGHT_SEARCH_RADIUS_DEGREES = 2;
exports.MIN_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS = 1;
exports.MAX_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS = 90;
exports.MIN_SPOTLIGHT_ELIGIBILITY_COUNT = 0;
exports.MAX_SPOTLIGHT_CHECKINS_ELIGIBILITY_COUNT = 100;
exports.MAX_SPOTLIGHT_RECENT_VIEWS_ELIGIBILITY_COUNT = 1000;
/** Approximate miles per degree of lat/lng, used only to present searchRadiusDegrees as a distance in the admin UI. */
exports.SPOTLIGHT_MILES_PER_DEGREE = 69;
function spotlightSearchRadiusDegreesToMiles(degrees) {
  return degrees * exports.SPOTLIGHT_MILES_PER_DEGREE;
}
function spotlightSearchRadiusMilesToDegrees(miles) {
  return miles / exports.SPOTLIGHT_MILES_PER_DEGREE;
}
exports.SPOTLIGHT_ELIGIBILITY_RULE_LABELS = {
  checkedIns: 'Current check-ins',
  recentViews: 'Recent viewers (peeks)',
  hasLogo: 'Has logo',
  activeSpecial: 'Active special or visit plans',
  sponsored: 'Sponsored (scheduled)'
};
exports.SPOTLIGHT_ELIGIBILITY_RULE_DESCRIPTIONS = {
  checkedIns: 'At least N users are checked in at the venue right now (live count from current_venue_id).',
  recentViews: 'At least N unique users peeked at the venue within the recent-views window above.',
  hasLogo: 'Venue has a logo_url configured. Useful to surface branded venues even when activity is low.',
  activeSpecial: 'Venue has special/event content active for the current date, time, and day-of-week, or at least one visit plan for today (server timezone).',
  sponsored: 'Venue has an admin-scheduled sponsored period covering right now (Venue.spotlightStartDate/spotlightEndDate). Promotes the venue to the "Sponsored" ticker card regardless of other activity.'
};
function buildDefaultSpotlightEligibilityConfig() {
  return {
    searchRadiusDegrees: exports.DEFAULT_SPOTLIGHT_SEARCH_RADIUS_DEGREES,
    recentViewsWindowDays: exports.DEFAULT_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS,
    rules: {
      checkedIns: {
        enabled: true,
        minCount: exports.DEFAULT_SPOTLIGHT_MIN_CHECKINS
      },
      recentViews: {
        enabled: true,
        minCount: exports.DEFAULT_SPOTLIGHT_MIN_RECENT_VIEWS
      },
      hasLogo: {
        enabled: true
      },
      activeSpecial: {
        enabled: true
      },
      sponsored: {
        enabled: true
      }
    }
  };
}
function parseCountRule(raw, fallback) {
  if (!raw || typeof raw !== 'object') {
    return _objectSpread({}, fallback);
  }
  const value = raw;
  return {
    enabled: typeof value.enabled === 'boolean' ? value.enabled : fallback.enabled,
    minCount: typeof value.minCount === 'number' && Number.isInteger(value.minCount) ? value.minCount : fallback.minCount
  };
}
function parseFlagRule(raw, fallback) {
  if (!raw || typeof raw !== 'object') {
    return _objectSpread({}, fallback);
  }
  const value = raw;
  return {
    enabled: typeof value.enabled === 'boolean' ? value.enabled : fallback.enabled
  };
}
function parseSpotlightEligibility(raw) {
  const defaults = buildDefaultSpotlightEligibilityConfig();
  if (!raw || typeof raw !== 'object') {
    return defaults;
  }
  const value = raw;
  const rulesRaw = value.rules && typeof value.rules === 'object' ? value.rules : {};
  const parsed = {
    searchRadiusDegrees: typeof value.searchRadiusDegrees === 'number' && Number.isFinite(value.searchRadiusDegrees) ? value.searchRadiusDegrees : defaults.searchRadiusDegrees,
    recentViewsWindowDays: typeof value.recentViewsWindowDays === 'number' && Number.isInteger(value.recentViewsWindowDays) ? value.recentViewsWindowDays : defaults.recentViewsWindowDays,
    rules: {
      checkedIns: parseCountRule(rulesRaw.checkedIns, defaults.rules.checkedIns),
      recentViews: parseCountRule(rulesRaw.recentViews, defaults.rules.recentViews),
      hasLogo: parseFlagRule(rulesRaw.hasLogo, defaults.rules.hasLogo),
      activeSpecial: parseFlagRule(rulesRaw.activeSpecial, defaults.rules.activeSpecial),
      sponsored: parseFlagRule(rulesRaw.sponsored, defaults.rules.sponsored)
    }
  };
  return ensureAtLeastOneSpotlightEligibilityRule(parsed);
}
function hasEnabledSpotlightEligibilityRule(rules) {
  return Object.values(rules).some(rule => rule.enabled);
}
/** If every rule is disabled, re-enable defaults so spotlight never returns zero candidates by misconfiguration. */
function ensureAtLeastOneSpotlightEligibilityRule(config) {
  if (hasEnabledSpotlightEligibilityRule(config.rules)) {
    return config;
  }
  return buildDefaultSpotlightEligibilityConfig();
}
function validateSpotlightEligibilityForSave(value) {
  if (!value || typeof value !== 'object') {
    return {
      message: 'spotlightEligibility must be an object.'
    };
  }
  const config = value;
  const radius = config.searchRadiusDegrees;
  if (typeof radius !== 'number' || !Number.isFinite(radius)) {
    return {
      message: 'spotlightEligibility.searchRadiusDegrees must be a number.'
    };
  }
  if (radius < exports.MIN_SPOTLIGHT_SEARCH_RADIUS_DEGREES || radius > exports.MAX_SPOTLIGHT_SEARCH_RADIUS_DEGREES) {
    return {
      message: "spotlightEligibility.searchRadiusDegrees must be between ".concat(exports.MIN_SPOTLIGHT_SEARCH_RADIUS_DEGREES, " and ").concat(exports.MAX_SPOTLIGHT_SEARCH_RADIUS_DEGREES, ".")
    };
  }
  const windowDays = config.recentViewsWindowDays;
  if (typeof windowDays !== 'number' || !Number.isInteger(windowDays)) {
    return {
      message: 'spotlightEligibility.recentViewsWindowDays must be an integer.'
    };
  }
  if (windowDays < exports.MIN_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS || windowDays > exports.MAX_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS) {
    return {
      message: "spotlightEligibility.recentViewsWindowDays must be between ".concat(exports.MIN_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS, " and ").concat(exports.MAX_SPOTLIGHT_RECENT_VIEWS_WINDOW_DAYS, ".")
    };
  }
  if (!config.rules || typeof config.rules !== 'object') {
    return {
      message: 'spotlightEligibility.rules must be an object.'
    };
  }
  const rules = config.rules;
  const countRuleError = (key, max) => {
    const raw = rules[key];
    if (!raw || typeof raw !== 'object') {
      return {
        message: "spotlightEligibility.rules.".concat(key, " must be an object.")
      };
    }
    const rule = raw;
    if (typeof rule.enabled !== 'boolean') {
      return {
        message: "spotlightEligibility.rules.".concat(key, ".enabled must be a boolean.")
      };
    }
    if (typeof rule.minCount !== 'number' || !Number.isInteger(rule.minCount)) {
      return {
        message: "spotlightEligibility.rules.".concat(key, ".minCount must be an integer.")
      };
    }
    if (rule.minCount < exports.MIN_SPOTLIGHT_ELIGIBILITY_COUNT || rule.minCount > max) {
      return {
        message: "spotlightEligibility.rules.".concat(key, ".minCount is out of range.")
      };
    }
    return null;
  };
  const checkedInsError = countRuleError('checkedIns', exports.MAX_SPOTLIGHT_CHECKINS_ELIGIBILITY_COUNT);
  if (checkedInsError) {
    return checkedInsError;
  }
  const recentViewsError = countRuleError('recentViews', exports.MAX_SPOTLIGHT_RECENT_VIEWS_ELIGIBILITY_COUNT);
  if (recentViewsError) {
    return recentViewsError;
  }
  for (const key of ['hasLogo', 'activeSpecial', 'sponsored']) {
    const raw = rules[key];
    if (!raw || typeof raw !== 'object') {
      return {
        message: "spotlightEligibility.rules.".concat(key, " must be an object.")
      };
    }
    const rule = raw;
    if (typeof rule.enabled !== 'boolean') {
      return {
        message: "spotlightEligibility.rules.".concat(key, ".enabled must be a boolean.")
      };
    }
  }
  const parsed = parseSpotlightEligibility(value);
  if (!hasEnabledSpotlightEligibilityRule(parsed.rules)) {
    return {
      message: 'At least one spotlight eligibility rule must be enabled.'
    };
  }
  return null;
}
//# sourceMappingURL=spotlight-eligibility-config.js.map